import { primaryColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const payWithBMBannerStyle = (theme) => ({
	bannerWrapper: {
		backgroundColor: primaryColor[0],
		padding: '24px',
		borderRadius: '8px',
	},
	bannerHeading: {
		fontFamily: `${theme.fontFamily.albert.bold} !important`,
		fontWeight: 700,
		color: `${whiteColor} !important`,
	},
	bannerDescription: {
		fontFamily: `${theme.fontFamily.albert.regular} !important`,
		color: `${whiteColor} !important`,
	},
	button: {
		fontFamily: `${theme.fontFamily.albert.regular} !important`,
		color: `${primaryColor[0]} !important`,
		backgroundColor: whiteColor,
		marginLeft: 'auto',
		textTransform: 'capitalize',
		display: 'block',
		maxWidth: ' fit-content',
		'&:hover': {
			color: `${primaryColor[0]} !important`,
			backgroundColor: whiteColor,
		},
	},
});

export default payWithBMBannerStyle;
